<template>
  <main class="pagina-sobre">
    <div class="pagina-sobre-nos">

      <section class="sobre-nos">
        <div class="titulo-pagina-sobre">
          <h2>SOBRE NÓS</h2>
        </div>

        <div
          v-for="item in sobre"
          :key="item.id"
          class="texto-sobre-pagina"
        >
          <p>{{ item.texto }}</p>

          <div class="foto-equipe">
            <img :src="item.foto" alt="Foto equipe" />
          </div>
        </div>
      </section>

     
    </div>
  </main>
</template>

<script setup>
import { sobre } from "@/data/sobre"
import { equipe } from "@/data/equipe"
</script>

<style>
.pagina-sobre {
  width: 100%;
  margin: 0 auto;
  gap: 10px;
}

.pagina-sobre-nos {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.titulo-pagina-sobre,
.titulo-pagina-equipe {
  width: 100%;
  margin: 110px auto 20px auto;
  text-align: center;
}

.sobre-nos {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.texto-sobre-pagina {
  width: 550px;
  height: 550px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  background: var(--card-gradiente), var(--fundo-card);
  border: 2px solid var(--borda-card);
  border-radius: 14px;
  box-shadow: var(--card-sombra);
}

.texto-sobre-pagina p {
  font-size: 18px;
  text-align: justify;
  letter-spacing: 0.5px;
  line-height: 1.5;
}

.foto-equipe {
  display: flex;
  justify-content: center;
}

.foto-equipe img {
  height: 200px;
  border-radius: 12px;
  object-fit: cover;
  border: 2px solid var(--borda-card);
  box-shadow: var(--card-sombra);
}

.membros {
  display: flex;
  flex-direction: column;
  gap: 35px;
}

.card-membros {
  width: 550px;
  height: auto;
  padding: 10px;
  display: flex;
  align-items: center;
  gap: 20px;
  background: var(--card-gradiente), var(--fundo-card);
  border: 2px solid var(--borda-card);
  border-radius: 14px;
  box-shadow: var(--card-sombra);
}

.card-membros > img {
  width: 180px;
  height: 180px;
  margin: auto;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  border: 2px solid var(--borda-card);
  box-shadow: var(--card-sombra);
}

.conteudo-membro {
  margin: auto;
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  text-align: left;
  letter-spacing: 0.5px;
}

.conteudo-membro h3 {
  margin: 0;
  font-size: 22px;
  color: var(--texto-titulo);
}

.conteudo-membro p {
  margin: 0;
  font-size: 14px;
  color: var(--texto-suave);
}

.conteudo-membro span {
  margin-top: 10px;
  font-size: 16px;
  color: var(--texto-suave);
  line-height: 1.2;
}

.redes-membros {
  margin: 12px 0 6px 0;
  display: flex;
  justify-content: center;
  gap: 10px;
}
</style>
